import { render, staticRenderFns } from "./CowsFarmBornRegistration.vue?vue&type=template&id=035abd80&scoped=true&"
import script from "./CowsFarmBornRegistration.vue?vue&type=script&lang=js&"
export * from "./CowsFarmBornRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035abd80",
  null
  
)

export default component.exports